import React from 'react';
import Tooltip from 'react-tooltip-lite';
import { useTranslation } from 'react-i18next';
import { FaEdit } from 'react-icons/fa';
import { DELAY_HTOOLTIP } from 'global/Global';

interface IEditButton {
  onClick?: () => void;
}

export default function EditButton(props: IEditButton) {
  const { t } = useTranslation();
  return (
    <>
      <Tooltip direction="down" eventOff="onClick" content={t('Table.Tooltip.Edit')} hoverDelay={DELAY_HTOOLTIP}>
        <FaEdit onClick={props.onClick} color="#05c" size={18} className="cursor-pointer" />
      </Tooltip>
    </>
  );
}
